import * as React from 'react';
type IconCalcuPaletizadoProps = React.SVGProps<SVGSVGElement>;

export const IconCalcuPaletizado: React.FC<IconCalcuPaletizadoProps> = (props) => (
<svg width={34} height={31} viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M0 25C0 24.4477 0.447715 24 1 24H33C33.5523 24 34 24.4477 34 25C34 25.5523 33.5523 26 33 26H1C0.447716 26 0 25.5523 0 25Z" fill="#FFA692"/>
<path d="M0 30C0 29.4477 0.447715 29 1 29H33C33.5523 29 34 29.4477 34 30C34 30.5523 33.5523 31 33 31H1C0.447716 31 0 30.5523 0 30Z" fill="#FFA692"/>
<path d="M3 25H6V29H3V25Z" fill="#FFA692"/>
<path d="M15 25H19V29H15V25Z" fill="#FFA692"/>
<path d="M28 25H31V29H28V25Z" fill="#FFA692"/>
<path d="M4 14C4 12.8954 4.89543 12 6 12H14C15.1046 12 16 12.8954 16 14V22C16 23.1046 15.1046 24 14 24H6C4.89543 24 4 23.1046 4 22V14Z" fill="#EBF8F0"/>
<path d="M11 2C11 0.895431 11.8954 0 13 0H21C22.1046 0 23 0.895431 23 2V10C23 11.1046 22.1046 12 21 12H13C11.8954 12 11 11.1046 11 10V2Z" fill="#EBF8F0"/>
<path d="M18 14C18 12.8954 18.8954 12 20 12H28C29.1046 12 30 12.8954 30 14V22C30 23.1046 29.1046 24 28 24H20C18.8954 24 18 23.1046 18 22V14Z" fill="#EBF8F0"/>
<path d="M8 12H12V17H8V12Z" fill="#7EAE90"/>
<path d="M15 0H19V5H15V0Z" fill="#7EAE90"/>
<path d="M22 12H26V17H22V12Z" fill="#7EAE90"/>
</svg>




);
export default IconCalcuPaletizado;
